import React from "react";

export const Factory360Section = () => {
  return (
    <section
      className="relative w-full overflow-hidden bg-white"
      style={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
    >
      <div className="relative w-full">
        {/* Full-width Base Image with Robot Arm & Conveyor Belt */}
        <img
          src="/images/physical-ai/factory-360-robot-arm.png"
          alt="Factory 360 - Robotic arm and automated conveyor system"
          className="w-full h-auto min-h-[380px] sm:min-h-0 object-cover sm:object-contain object-bottom block select-none pointer-events-none"
        />

        {/* Text Layer Overlayed in the Top White Space with IoT 5.0 Card */}
        <div className="absolute inset-x-0 top-0 z-10 px-4 sm:px-6 lg:px-[70px]">
          <div className="mx-auto max-w-[1440px] relative pt-6 sm:pt-8 md:pt-9 lg:pt-11 xl:pt-12">
            
            {/* IoT 5.0 Floating Card (Figma Specs: Width: 240px, Height: 69px, Top: 46px, Left: 1131px) */}
            <div
              className="hidden md:flex absolute top-[20px] sm:top-[30px] lg:top-[46px] right-0 items-center w-[240px] h-[69px] rounded-[16px] px-3.5 select-none shadow-[0_2px_12px_rgba(0,102,204,0.04)] border border-[#DCEAF5]"
              style={{ backgroundColor: "rgba(239, 248, 255, 1)" }}
            >
              {/* IoT Network Icon */}
              <div className="shrink-0 flex items-center justify-center">
                <svg
                  viewBox="0 0 34 34"
                  className="w-[32px] h-[32px]"
                  fill="none"
                  stroke="#627E92"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {/* Spokes */}
                  <line x1="13.2" y1="13.2" x2="8" y2="8.5" />
                  <line x1="12.5" y1="18.5" x2="7.5" y2="21.5" />
                  <line x1="17" y1="21.2" x2="17" y2="26" />
                  <line x1="21" y1="18.8" x2="25.5" y2="21" />
                  <line x1="20.5" y1="13.5" x2="25" y2="9.5" />
                  
                  {/* Center Node */}
                  <circle cx="17" cy="17" r="4.2" strokeWidth="1.9" />
                  
                  {/* 5 Outer Satellite Nodes */}
                  <circle cx="6.8" cy="7.8" r="2.3" strokeWidth="1.8" />
                  <circle cx="6" cy="22.5" r="2.3" strokeWidth="1.8" />
                  <circle cx="17" cy="27.5" r="2.3" strokeWidth="1.8" />
                  <circle cx="27" cy="22" r="2.3" strokeWidth="1.8" />
                  <circle cx="26.5" cy="8.5" r="2.3" strokeWidth="1.8" />
                </svg>
              </div>

              {/* Vertical Divider */}
              <div className="w-[1.2px] h-[38px] bg-[#CFDDE8] mx-3 shrink-0" />

              {/* Text Info */}
              <div className="flex flex-col justify-center min-w-0">
                <span className="text-[20px] font-bold tracking-[-0.4px] text-[#556F82] leading-none">
                  IoT 5.0
                </span>
                <span className="mt-1 text-[10.5px] leading-[13.5px] font-normal text-[#718A9C] block whitespace-nowrap">
                  Connected, Intelligent and Human-<br />centric operations
                </span>
              </div>
            </div>

            {/* Centered Headlines & Paragraph */}
            <div className="mx-auto max-w-[850px] text-center">
              {/* Eyebrow Tag */}
              <p className="text-[10px] sm:text-[11px] md:text-[11.5px] lg:text-[12px] font-bold uppercase tracking-[2.8px] text-[#6B7280]">
                FACTORY 360
              </p>

              {/* Main Headline */}
              <h2
                className="mt-2 sm:mt-2.5 md:mt-3 lg:mt-3.5 text-[20px] sm:text-[26px] md:text-[30px] lg:text-[38px] xl:text-[44px] font-bold tracking-[-1.2px] text-[#0A1629] leading-[1.18]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <span className="block">Make every physical process</span>
                <span className="block mt-0.5 sm:mt-1">
                  observable, measurable and{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, rgba(0, 136, 255, 1) 0%, rgba(10, 102, 255, 1) 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    AI-ready.
                  </span>
                </span>
              </h2>

              {/* Subtitle / Paragraph */}
              <p className="mt-2 sm:mt-2.5 md:mt-3 lg:mt-4 text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14.5px] xl:text-[15.5px] leading-[16px] sm:leading-[19px] md:leading-[22px] lg:leading-[25px] text-[#5B6B82] max-w-[760px] mx-auto">
                Factory 360 connects machines, assets, materials, people and processes to create a real-time digital understanding of the factory floor—providing the data foundation for automation, analytics and Physical AI.
              </p>

              {/* Mobile-only IoT 5.0 badge */}
              <div className="flex md:hidden mx-auto mt-4 items-center justify-center">
                <div
                  className="inline-flex items-center w-[230px] h-[64px] rounded-[16px] px-3 py-1.5 shadow-[0_2px_10px_rgba(0,102,204,0.04)] border border-[#DCEAF5]"
                  style={{ backgroundColor: "rgba(239, 248, 255, 1)" }}
                >
                  <div className="shrink-0 flex items-center justify-center">
                    <svg
                      viewBox="0 0 34 34"
                      className="w-[28px] h-[28px]"
                      fill="none"
                      stroke="#5E778B"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="13.2" y1="13.2" x2="8" y2="8.5" />
                      <line x1="12.5" y1="18.5" x2="7.5" y2="21.5" />
                      <line x1="17" y1="21.2" x2="17" y2="26" />
                      <line x1="21" y1="18.8" x2="25.5" y2="21" />
                      <line x1="20.5" y1="13.5" x2="25" y2="9.5" />
                      <circle cx="17" cy="17" r="4.2" strokeWidth="1.9" />
                      <circle cx="6.8" cy="7.8" r="2.3" strokeWidth="1.8" />
                      <circle cx="6" cy="22.5" r="2.3" strokeWidth="1.8" />
                      <circle cx="17" cy="27.5" r="2.3" strokeWidth="1.8" />
                      <circle cx="27" cy="22" r="2.3" strokeWidth="1.8" />
                      <circle cx="26.5" cy="8.5" r="2.3" strokeWidth="1.8" />
                    </svg>
                  </div>
                  <div className="w-[1.5px] h-[32px] bg-[#CCDDEB] mx-2 shrink-0" />
                  <div className="flex flex-col justify-center text-left min-w-0">
                    <span className="text-[15.5px] font-bold tracking-tight text-[#577286] leading-none">
                      IoT 5.0
                    </span>
                    <span className="mt-0.5 text-[9px] leading-[12px] font-medium text-[#70899C]">
                      Connected, Intelligent and Human-centric operations
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Factory360Section;
